import { render, staticRenderFns } from "./ConfigMesComercial.vue?vue&type=template&id=23b83602&scoped=true&"
import script from "./ConfigMesComercial.vue?vue&type=script&lang=js&"
export * from "./ConfigMesComercial.vue?vue&type=script&lang=js&"
import style0 from "./ConfigMesComercial.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ConfigMesComercial.vue?vue&type=style&index=1&id=23b83602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b83602",
  null
  
)

export default component.exports